module.exports = __webpack_public_path__ + "img/Airbnb-Working-Office-Posture-Perfect2-scaled.e5fbce98.jpg";